import ClubEmployeeDepartmentRelation from '../dto/ClubEmployeeDepartmentRelation';
import Department from '../dto/Department';
import Error from '../model/Error';
import Member from '../dto/Member';
import MemberWithAttendances from '../dto/MemberWithAttendances';
import Team from '../dto/Team';
import axios from 'axios';

export default class DepartmentRepository {

    static findAll(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/departments`)
                .then(response => resolve(response.data.data.map(data => Department.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findChildDepartments(departmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/departments/${departmentId}/child-departments`)
                .then(response => resolve(response.data.data.map(data => Department.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static find(departmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/departments/${departmentId}`)
                .then(response => resolve(Department.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(department, clubId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/departments`, department)
                .then(response => resolve(response.headers['location'].split('/').pop()))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(department) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/departments/${department.id}`, department.serialize())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static remove(department) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/departments/${department.id}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static uploadImage(department, image, progressCallback) {
        const config = {
            onUploadProgress: function (progressEvent) {
                if (progressCallback) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    progressCallback(percentCompleted);
                }
            },
            headers: {'Content-Type': 'application/octet-stream'}
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/departments/${department.id}/image`, image, config)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeImage(department) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/departments/${department.id}/image`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findMembers(departmentId, status, type, search, sort, limit, offset) {
        let params = {
            status,
            type,
            sort,
            limit,
            offset
        };
        if (search !== null) {
            params.search = search;
        }
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/departments/${departmentId}/members?include=academicTitle`, { params })
                .then(response => resolve(response.data.data.map(data => Member.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findEmployees(departmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/departments/${departmentId}/employees`)
                .then(response => resolve(response.data.data.map(data => ClubEmployeeDepartmentRelation.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findTeams(departmentId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/departments/${departmentId}/teams`)
                .then(response => resolve(response.data.data.map(data => Team.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findMemberAttendancesForDate(departmentId, date, search, attendancesOnly, openAttendancesOnly) {
        const params = {
            date,
            search,
            attendancesOnly,
            openAttendancesOnly
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/departments/${departmentId}/member-attendances`, { params })
                .then(response => resolve(response.data.data.map(data => MemberWithAttendances.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateMemberAttendance(attendanceId, start, end) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/department-member-attendances/${attendanceId}`, {start, end})
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeMemberAttendance(attendanceId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/department-member-attendances/${attendanceId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
